import React from 'react';
import ClientInvoices from '../client/Invoices';

const OperatorFacturacion = () => {
  return <ClientInvoices />;
};

export default OperatorFacturacion;
